import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { Loading } from "element-ui";
import $api from "../plugins/http/api";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loading: "", //loading
    languageList: null, //语言列表
    language: null, //当前语言

    detail: {}, //当前报名活动
    registe: null, //报名回执
    // 当前的国家
    currentCountry: {},
    languaClass: "",
    // 用户信息
    userInfo: {},
    reviewDetailInfo: {
      raceParticipantInfo: {
        username: "",
        age: "",
        email: "",
        phone: "",
      },
      raceExperience: "",
      raceAttachment: [],
    },
    registerInfo: {
      invitationCode: "",
      raceType: "",
    },
  },
  getters: {
    languaClass: "",
  },
  getters: {},
  mutations: {
    SET_USER_INFO(state, payload) {
      state.userInfo = payload;
    },
    SET_REGISTER_INFO(state, payload) {
      state.registerInfo = payload;
    },
    SET_CURRENT_COUNTRY(state, data) {
      state.currentCountry = data;
    },
    SET_REVIEW_DETAIL_INFO(state, data) {
      state.reviewDetailInfo = data;
    },
    SET_LANGUAGELIST(state, data) {
      state.languageList = data;
    },
    SET_LANGUAGE(state, data) {
      state.language = data;
      if (data == "vn") {
        // state.languaClass = "vn_font_family";
      } else if (data == "th") {
        // state.languaClass = "th_font_family";
      } else {
        state.languaClass = "";
      }
    },
    SET_REGISTE(state, data) {
      state.registe = data;
    },
    SET_DETAIL(state, data) {
      state.detail = data;
    },
  },
  actions: {
    async getUserInfo({ commit }) {
      try {
        const { code, data } = await $api.getUserInfo(); // 请求用户信息的函数
        if (code === 200) {
          commit("SET_USER_INFO", data);
        } else {
          commit("SET_USER_INFO", {});
        }
      } catch (error) {
        commit("SET_USER_INFO", {});
      }
    },
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage, // 或者 localStorage
    }),
  ],
});

export default store;
